const list = {
    search: [
      
        {
            showField: "银行名称",
            entityField: "name",
            fieldType: "string",
            formatterContent:null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
        },

    ],
    list: [
        // {
        //     showField: "控销类型",
        //     entityField: "type",
        //     fieldType: "formatter",
        //     formatterContent: JSON.stringify([
        //         {
        //             key: "单位类型",
        //             value: 0
        //         },
        //         {
        //             key: "客户",
        //             value: 1
        //         },
        //         {
        //             key: "区域",
        //             value: 2
        //         },
        //         {
        //             key: "流向",
        //             value: 3
        //         },
        //     ]),
        //     fieldWeight: 110,
        // },
        // {
        //     showField: "业务类型",
        //     entityField: "businessType",
        //     fieldType: "formatter",
        //     formatterContent: JSON.stringify([
        //         {
        //             key: "只可卖",
        //             value: 1
        //         },
        //         {
        //             key: "不可卖",
        //             value: 0
        //         },
        //     ]),
        //     fieldWeight: 110,
        // },
        {
            showField: "银行名称",
            entityField: "bankName",
            fieldType: "string",
            fieldWeight: 100,
        },
        {
            showField: "规则",
            entityField: "readRule",
            fieldType: "string",
            fieldWeight: 300,
        },
        // {
        //     showField: "创建时间",
        //     entityField: "createTime",
        //     fieldType: "date",
        //     fieldWeight: 110,
        // },
    ],
    from: {
        //单位类型列表
        typelist: [
            {
                showField: "单位类型",
                entityField: "diName",
                fieldType: "input",
                fieldWeight: 150,
            },
        ],
        //客户列表
        buyerlist: [
            {
                showField: "客户名称",
                entityField: "cmName",
                fieldType: "search",
                searchId: 157783642640384,
                setField: "cmName,cmId,cmCode",
                fieldWeight: 150,
            },
            {
                showField: "客户编号",
                entityField: "cmCode",
                fieldType: "string",
                fieldWeight: 120,
            },

        ],
        //区域列表
        regionlist: [
            {
                showField: "区域名称",
                entityField: "regionName",
                fieldType: "input",
                fieldWeight: 150,
            },
        ],
        //商品列表
        productlist: [
            {
                showField: "通用名称",
                entityField: "bgmName",
                fieldType: "search",
                searchId: 853533363572736,
                setField: "bgmName,bgmId,bgmCode,spec,manufacturer,placeorigin,packingSpec,bgpUnitmeasurement",
                fieldWeight: 200,
            },
            {
                showField: "商品编号",
                entityField: "bgmCode",
                fieldType: "string",
                fieldWeight: 150,
            },
            {
                showField: "规格",
                entityField: "spec",
                fieldType: "string",
                fieldWeight: 120,
            },
            {
                showField: "生产厂商",
                entityField: "manufacturer",
                fieldType: "string",
                fieldWeight: 160,
            },
            {
                showField: "产地",
                entityField: "placeorigin",
                fieldType: "string",
                fieldWeight: 90,
            },
            {
                showField: "装箱规格",
                entityField: "packingSpec",
                fieldType: "string",
                fieldWeight: 120,
            },
            {
                showField: "包装单位",
                entityField: "bgpUnitmeasurement",
                fieldType: "string",
                fieldWeight: 120,
            },
        ],
    }
}
export default list
